import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import AppsDiamondLinksService from "../../../services/apps-diamondlinks.service";
import { Spin, Table, Tooltip } from "antd";


const ViewInquiry = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [dealerId, setDealerId] = useState();
  const [viewInquiryList, setviewInquiryList] = useState([]);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(1000);

  const loginDetials = useSelector((state) => state.loginReducer);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleviewInquiryData(
            loginDetials.loginDetials.responseData.dealerId,
            pageNo,
            pageSize
          );
        }
      }
    }
  }, []);

  const handleviewInquiryData = (id, pageNo, pageSize) => {
    let inputData = {
      dealerID: id,
      pageNumber: pageNo,
      pageSize: pageSize,
    };
    setLoading(true);
    try {
      AppsDiamondLinksService.GetviewInquiry(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData[0]) {
              setLoading(false);
              setviewInquiryList(responseData[0].viewinquireylist);
              setTotalCount(responseData[0].totalRecord);
            }
          } else {
            setLoading(false);
            setviewInquiryList([]);
            setTotalCount(0);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const columns = [
    {
      title: <Tooltip title={t("First Name")}>{t("First Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "firstName",
    },
    {
      title: <Tooltip title={t("Last Name")}>{t("Last Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "lastName",
    },
    {
      title: <Tooltip title={t("Phone Number")}>{t("Phone Number")}</Tooltip>,
      ellipsis: true,
      dataIndex: "phoneNumber",
    },
    {
      title: <Tooltip title={t("Email Address")}>{t("Email Address")}</Tooltip>,
      ellipsis: true,
      dataIndex: "emailAddress",
    },
    {
      title: <Tooltip title={t("Comments")}>{t("Comments")}</Tooltip>,
      ellipsis: true,
      dataIndex: "comments",
    },
  ];

  function handlePageNoChange(page, pageSize) {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setPageNo(page);
    handleviewInquiryData(page, pageSize);
  }
  function handlePageSizeChange(current, size) {
    setPageSize(size);
    handleviewInquiryData(current, size);
  }

  return (
    <React.Fragment>
      <div className="pendjewelreq__section magento__mapping">
        <div className="form__fields">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">{t("View Inquiry")}</h4>
            </div>
          </div>
          <div className="col-lg-12 col-md-12">
            <Table
              className="pendjewelreq__tbl"
              columns={columns}
              dataSource={viewInquiryList}
              onChange={(pagination, filters, sorters) => {
                document
                  .getElementsByClassName("content__area")[0]
                  .scroll(0, 0);
              }}
              pagination={{
                size: "small",
                total: totalCount,
                pageNo: pageNo,
                pageSize: pageSize,
                pageSizeOptions: [10, 15, 20, 50, 100],
                responsive: true,
                showSizeChanger: true,
                onChange: handlePageNoChange,
                onShowSizeChange: handlePageSizeChange,
              }}
              loading={{ size: "large", spinning: loading }}
            />

            <hr />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewInquiry;
